<div class="flex size-full flex-col items-center justify-center gap-4">
  <!-- stretched so all cards in the row are as tall as the tallest -->
  <div class="flex items-stretch gap-4">
    @for (assignment of comp().assignments; track assignment.uid) {
      <rid-stop-assignment
        class="w-40 min-w-0 transition-opacity"
        [class.animate-pulse]="startingUid() === assignment.uid"
        [config]="assignment"
        [finished]="isFinished(assignment)"
        (clicked)="startAssignment(assignment)"
      />
    }
  </div>

  @if (failedUid()) {
    <p class="font-default rounded-xl bg-white px-4 py-2 text-center font-bold text-red-700">
      Deze opdracht kon niet starten. Probeer het later nog eens.
    </p>
  }
</div>
